import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import cx from 'classnames';

import { translate } from '../../../../utils/helpers';
import TableRowWithActions from '../../../../components/UI/TableRowWithActions';
import { sortStateType, SORT_KEYS } from '../SingleTeamView/const';
import { useStyles } from '../SingleTeamTableRow';
import useHeaderStyles from './styles';

interface SingleTeamTableHeaderProps {
  handleSort: Function;
  sortState: sortStateType;
}

const SingleTeamTableHeader: FC<SingleTeamTableHeaderProps> = ({ handleSort, sortState }) => {
  const classes = useStyles();
  const headerClasses = useHeaderStyles();

  return (
    <TableRowWithActions cellsClass={headerClasses.headerWrap}>
      <>
        <Box
          display="flex"
          alignItems="center"
          className={cx(classes.learnerCell, classes.tableCell, headerClasses.header)}
          onClick={() => handleSort(SORT_KEYS.name)}
        >
          {translate('page.account.learner')}
          <ArrowDropDownIcon
            className={cx(
              sortState?.key === SORT_KEYS.name && headerClasses.activeArrow,
              sortState?.state === 1 && 'arrow-up',
            )}
            fontSize="small"
          />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          className={cx(classes.tableCell, headerClasses.header, 'hidden-on-mobile')}
          onClick={() => handleSort(SORT_KEYS.role)}
        >
          {translate('page.account.role')}
          <ArrowDropDownIcon
            className={cx(
              sortState?.key === SORT_KEYS.role && headerClasses.activeArrow,
              sortState?.state === 1 && 'arrow-up',
            )}
            fontSize="small"
          />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          className={cx(classes.tableCell, headerClasses.header)}
          onClick={() => handleSort(SORT_KEYS.lastLogin)}
        >
          {translate('page.account.lastLogin')}
          <ArrowDropDownIcon
            className={cx(
              sortState?.key === SORT_KEYS.lastLogin && headerClasses.activeArrow,
              sortState?.state === 1 && 'arrow-up',
            )}
            fontSize="small"
          />
        </Box>
      </>
    </TableRowWithActions>
  );
};

export default SingleTeamTableHeader;
